import { periodToRange } from '../../api/dashboards'
import { productivityApi } from '../../api/productivity'
import { DataTable } from '../ui'
import type { WidgetProps } from './types'
import { useWidgetData } from './useWidgetData'
import { WidgetBody, formatNum } from './WidgetBody'

/** Produttività del team: il server limita le righe al sottoalbero del Manager (Admin: tutti). */
export function TeamProductivityWidget({ item }: WidgetProps) {
  const range = periodToRange(item.filters?.period)
  const teamOf = item.filters?.teamOf ? String(item.filters.teamOf) : undefined
  const state = useWidgetData(() => productivityApi.report({ ...range, teamOf }), JSON.stringify([range, teamOf]))
  return (
    <WidgetBody state={state}>
      {report => (
        <DataTable>
          <thead>
            <tr>
              <th>Utente</th>
              <th className="text-end">Task</th>
              <th className="text-end">Lead</th>
              <th className="text-end">Pratiche</th>
              <th className="text-end">Fuori SLA</th>
            </tr>
          </thead>
          <tbody>
            {report.rows.map(r => (
              <tr key={r.userId}>
                <td>{r.name ?? `Utente ${r.userId}`}</td>
                <td className="text-end md-num">{formatNum(r.metrics.tasksCompleted)}</td>
                <td className="text-end md-num">{formatNum(r.metrics.leadsWorked)}</td>
                <td className="text-end md-num">{formatNum(r.metrics.practicesProcessed)}</td>
                <td className="text-end md-num">{formatNum(r.metrics.outOfSlaNow)}</td>
              </tr>
            ))}
          </tbody>
        </DataTable>
      )}
    </WidgetBody>
  )
}
